<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <strong>ShopO predict Product Category</strong>
          </div>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="link">Link</label>
                <b-form-input
                  type="text"
                  id="link"
                  v-model="link"
                  placeholder="E.g.: http://redirect.viglink.com?u=http%3A%2F%2Fwww.sitename...."
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="title">Title</label>
                <b-form-input
                  v-model="title"
                  type="text"
                  id="title"
                  placeholder="E.g.: Men's red t-shirt ..."
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="description">Description</label>
                <b-form-input
                  v-model="description"
                  type="text"
                  id="description"
                  placeholder="E.g.: Men's red t-shirt description..."
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="size">Size</label>
                <b-form-input v-model="size" type="text" id="size" placeholder="E.g.: XL"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="color">Color</label>
                <b-form-input v-model="color" type="text" id="color" placeholder="E.g.: Black"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <div slot="footer">
            <b-button type="submit" size="sm" variant="primary" v-on:click="predictCategory">
              <i class="fa fa-search"></i> Predict
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <small class="text-muted text-uppercase font-weight-bold">Predicted category:</small>
          <div class="h5 mb-0">{{predictedCategory}}</div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <small class="text-muted text-uppercase font-weight-bold">
            API reference can be found
            <a :href="apiUrl+'../api-docs'">HERE</a> and
            <a :href="apiUrl+'../reference'">HERE</a>
          </small>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import Vue from "vue"

export default {
  data: function () {
    return {
      predictedCategory: '-',
      link: '',
      size: '',
      title: '',
      color: '',
      description: '',
      apiUrl: process.env.VUE_APP_API_URL
    }
  },
  methods: {
    predictCategory: async function () {
      this.$data.predictedCategory = "Processing......."
      try {
        let response = await Vue.axios.post(new URL(process.env.VUE_APP_API_URL + `shopo/predict-category`),
          {
            'link': this.$data.link,
            'title': this.$data.title,
            'description': this.$data.description,
            'size': this.$data.size,
            'color': this.$data.color
          });
        this.$data.predictedCategory = response.data.category;
      } catch (error) {
        this.$data.predictedCategory = 'Error happened while processing your request.'
      }
    }
  }
}

</script>